<template>
  <div class="tab1">
    <div class="box1">
      <div class="title">
        <div class="icon">
          <span class="before"></span>
          <span class="after"></span>
        </div>
        <div>ESG的概念</div>
      </div>
      <div class="desc">
        ESG是环境(Environmental)、社会(Social)及公司治理(Governance) 三个单词的英文首字母缩写，是一种关注企业环境、社会、治理绩效而非财务绩效的可持续投资理念，反映了企业在促进经济可持续发展、履行环境与社会责任等方面的贡献，已经日益成为衡量企业可持续发展能力、影响投资者决策的关键因素。
      </div>
      <div class="img1-1"></div>
    </div>
    <div class="box2">
      <div class="box2-container">
        <div class="title">
          <div class="icon">
            <span class="before"></span>
            <span class="after"></span>
          </div>
          <div>ESG的起源与发展</div>
        </div>
        <div class="img1-2"></div>
      </div>
    </div>
    <div class="box3">
      <div class="title">
        <div class="icon">
          <span class="before"></span>
          <span class="after"></span>
        </div>
        <div>ESG在中国发展现状</div>
      </div>
      <div class="desc">
          目前，我国ESG投资发展还处于初期阶段，近年来，ESG投资的规模和增速均呈持续稳定增长态势，随着ESG相关的政策制度和评价体系不断完善，绿色金融的理念越来越深入人心，我国ESG将逐渐获得快速发展。
      </div>
      <div class="img1-3"></div>
    </div>            
    <div class="box4">
      <div class="box4-container">
        <div class="title">
          <div class="icon">
            <span class="before"></span>
            <span class="after"></span>
          </div>
          <div>国内企业的ESG实践</div>
          </div>
          <div class="container">
            <div class="itemContainer">
              <div class="img1-4"></div>
              <div class="descOuter">
                <div class="itemTop"><span class="itemTitle">信息披露：</span><span class="itemDesc">2020年1012家A股上市公司独立发布ESG报告，ESG信息披露质量提高</span></div>
                <div><span class="itemTitle">治理理念：</span><span class="itemDesc">公众公司与非上市公司的区别意识，以及公司治理是公众公司中心环节的共识日益深入人心</span></div>
              </div>
            </div>
            <div class="itemContainer">
              <div class="img1-5"></div>
              <div class="descOuter">
                <div class="itemTop"><span class="itemTitle">责任价值：</span><span class="itemDesc">带头践行ESG绿色治理、助力“双碳”目标、巩固脱贫成果、贡献公益慈善；节能减排、保障劳工权益、确保安全生产、防范经营发展中的社会环境风险
</span></div>
                <div><span class="itemTitle">社会表率：</span><span class="itemDesc">国有企业、中央企业带头履行社会责任重点工作；从深化研究、能力建设、搭建平台等方面推动ESG建设
</span></div>
              </div>
            </div>
            <div class="itemContainer">
              <div class="img1-6"></div>
              <div class="descOuter">
                <div class="itemTop"><span class="itemTitle">生态布局：</span><span class="itemDesc">更多民企积极参与绿色治理，在ESG生态建设进程优先布局

</span></div>
                <div><span class="itemTitle">加强信任：</span><span class="itemDesc">提升ESG能力、完善ESG成果披露、增强可持续发展领域话语权，增进企业与消费者及监管方信任关系；促进企业经济效益与社会效益、生态效益统一</span></div>
              </div>
            </div>
          </div>
      </div>
    </div>              
  </div>
</template>
<script>
//import { mapActions } from "vuex";
//import List from "./components/List";
export default {
  data() {
    return {
      
      //activeName: "0",
    };
  },
  components: {
   /*  List, */
  },
  computed: {

  },//
  mounted() {
    /* this.getLeftMenuList().then((data) => {
      this.leftMenus = data;
    }); */
  },
  methods: {
    /* ...mapActions("dynamicInfo/index", {
      getTabMenuList: "GET_TAB_MENU_LIST",
    }), */
    /* leftSelect(index) {
      let currentMenu = this.leftMenus[index];
      this.classifyCode = currentMenu.code;
    }, */
/*     handleClick(tab, event) {
        console.log(tab, event);
        let code=tab.name;
        console.log(tab.name)
          this.getInfoList(code).then((data)=>{
          console.log(data)
          this.infoList=data.data
        })
        
        
      }  */   
  },
};
</script>
<style lang="scss" scoped>
.Black{
  .tab1{
    .title{
      color: var(--font_01);
    }
    .desc{
      color: var(--font_01);
    }
    .box2{
      
      .box2-container{
        .img1-2{
        background: url('../../../assets/black_theme/esg-college-tab1-2.png') no-repeat;
        background-position: center;
        background-size: cover;
      
        }
      }
      
    }
    .img1-3{
        
      background: url('../../../assets/black_theme/esg-college-tab1-3.png') no-repeat;
      background-position: center;
      background-size: cover;
    
    }
    .box4{
      
      .box4-container{
        .container{
        display: flex;
        justify-content: space-between;
        margin-bottom: 77px;
        .itemContainer{
          border: 1px solid #223750;
          .descOuter{
            background-color: #011A36;
            color: var(--font_01);
          }
        }
    }
      }
    }
    
  }
}
    .tab1{
      width: 100%;
      //height: 438px;
      .box1{
        width: 1100px;
        margin: 0 auto;
      }
      .box3{
        width: 1100px;
        margin: 0 auto;
      }
      .title{
        display: flex;
        margin-top: 10px;
        margin-bottom: 20px;
        padding-left: 2px;
        font-weight: bold;
        font-size: 16px;
        .icon{
          position: relative;
          margin-right: 10px;
          margin-top: 4px;
          .before{
            position: absolute;
            top: 2px;
            left: -2px;
            width: 10px;
            height: 10px;
            background-color: #008BCE;
          }
          .after{
            display: block;
            width: 10px;
            height: 10px;
            background-color: #008BCE;
            opacity: 0.19;
          }

        }
      }
      .desc{
        line-height: 22px;
        margin-bottom: 20px;
        
      }
      .img1-1{
        width: 840px;
        height: 185px;
        margin: 0 auto;
        background: url('../../../assets/white_theme/esg-college-tab1-1.png') no-repeat;
        background-position: center;
        background-size: cover;
        margin-bottom: 50px;
      }
      .box2{
        /* width: 1120px;
        margin: 0 auto; */
        padding-bottom: 50px;
        margin-bottom: 50px;
        
        .box2-container{
          width: 1120px;
          margin: 0 auto;
          padding-top: 50px;
          .img1-2{
            width: 604px;
            height: 581px;
            
            margin: 0 auto;
            background: url('../../../assets/white_theme/esg-college-tab1-2.png') no-repeat;
            background-position: center;
            background-size: cover;
            
            /* background-color: #fff; */
          }
        }
        
      }
      .img1-3{
        width: 604px;
        height: 797px;
        
        margin: 0 auto;
        background: url('../../../assets/white_theme/esg-college-tab1-3.png') no-repeat;
        background-position: center;
        background-size: cover;
        margin-bottom: 100px;
      }
      .box4{
        padding-bottom: 50px;
        .box4-container{
          width: 1120px;
          margin: 0 auto;
          padding-top: 50px;
          .container{
            display: flex;
            justify-content: space-between;
            margin-bottom: 77px;
            .itemContainer{
              width: 280px;
              height: 310px;
              border: 1px solid #E7E7E7;
              .img1-4{
                width: 280px;
                height: 131px;
                background: url('../../../assets/white_theme/esg-college-tab1-4.png') no-repeat;
                background-position: center;
                background-size: cover;
              }
              .img1-5{
                width: 280px;
                height: 131px;
                background: url('../../../assets/white_theme/esg-college-tab1-5.png') no-repeat;
                background-position: center;
                background-size: cover;
              }
              .img1-6{
                width: 280px;
                height: 131px;
                background: url('../../../assets/white_theme/esg-college-tab1-6.png') no-repeat;
                background-position: center;
                background-size: cover;
              }
              .descOuter{
                width: 278px;
                height: 177px;
                padding: 16px 26px;
                background-color: #fff;
                .itemTop{
                  margin-bottom: 12px;
                  
                }
                .itemTitle{
                    font-size: 12px;
                    font-weight: bold;
                    line-height: 17px;
                  }
                  .itemDesc{
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 17px;
                  }
                
              }
            }

          }
        }
      }
    }
  
    

</style>
